import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTRPC, useTRPCClient } from "@/trpc";
import type { RouterInputs } from "@/trpc";
import { toast } from "sonner";

type CreateAdHocTimeEntryInput =
  RouterInputs["timeEntry"]["createAdHocTimeEntry"];

/**
 * Hook for creating ad-hoc time entries.
 */
export function useCreateAdHocTimeEntry() {
  const trpc = useTRPC();
  const trpcClient = useTRPCClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateAdHocTimeEntryInput) =>
      trpcClient.timeEntry.createAdHocTimeEntry.mutate(input),
    onSuccess: () => {
      toast.success("Time entry submitted for review");
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to submit time entry");
    },
    onSettled: () => {
      // Invalidate related queries to refresh the UI
      queryClient.invalidateQueries({
        queryKey: trpc.timeEntry.getShiftsNeedingEntries.queryKey(),
      });
      queryClient.invalidateQueries({
        queryKey: trpc.timeEntry.getSubmittedTimeEntries.queryKey(),
      });
    },
  });
}
